import * as React from 'react';

export interface LazyImageContextValues {
    handleRef: ((element: HTMLImageElement | null) => void) | null;
}

export const LazyImageContext = React.createContext<LazyImageContextValues>({
    handleRef: null,
});
